import { render } from "./IconTitle.vue?vue&type=template&id=3c77dab9&scoped=true"
import script from "./IconTitle.vue?vue&type=script&lang=js"
export * from "./IconTitle.vue?vue&type=script&lang=js"

import "./IconTitle.vue?vue&type=style&index=0&id=3c77dab9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c77dab9"]])

export default __exports__